// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"8c28726d","203":"8c28726d","771":"fe05d278","797":"8c28726d","841":"fe05d278"}[chunkId] + ".chunk.css";
};